import Vuex from 'vuex'
// import Vue from "vue";
import {router} from "../router"
import ApiAuthentificationService from '../services/ApiAuthenticationService'
import utils from './Utils';

//STATE
const state = {
  scrollToBeforeLeave: 0,
  scrollToBeforeEnter: 0,
  count: 0,
  isLogged: false,
  pageTransition: {
    name: "router-view",
    mode: "in-out"
  },  
  login:{
      title:"Connexion à votre espace",
      id:"Identifiant",
      id_placeholder:"bcatinot@feelity.fr",
      password:"Mot de passe",
      password_placeholder:"Passw0rd",
      bt_connection: 'Connexion',
      bt_forget:"Mot de passe oublié ?",
      error:'Erreur',
      error_desc:'Votre login ou mot de passe sont incorrect !',
      src:'/img/logo.svg',
  },
  blog:{
    title:'1ère excursion - Taux AEL',
    dateEnd:'Date de fin',
    dateStart:'31 mai',
    src:'/img/placeholder.png',
    content:'<p><b>Avec plus de 5000 nouvelles connexions en avril l´excursion se poursuit jusqu´au 31 mai.</b></p><h4>RAPPEL : bonification supplémentaire :</h4><p>de 5 points dès que le taux a progressé de 3 points (soit 15 + 5 = 20)</p><p>de 10 points dès le taux a progressé de 5 points (soit 25 + 10 = 35)</p><h4>RAPPEL : bonification supplémentaire :</h4><p>Depuis mars 2020, les marchés financiers ont enregistré une baisse significative, le seul CAC 40 perdant près de 40% de sa valeur en un mois, les marchés actions internationaux perdant 30%.</p><br><p>En notre qualité d´assureur et donc d´investisseur de long terme, nous pouvons proposer à nos clients de se repositionner sur les marchés financiers en investissant sur nos unités de comptes.</p><p>En effet, les mesures de soutien à l´économie mises en place par les banques </p>'
  },  
  boutique:{
    src:'/img/shop.png',
    content:'<p><b>Vous pouvez rentrer dans la boutique cadeaux, dans laquelle vous allez découvrir les lots auxquels les meilleurs d’entre vous pourront accéder dès la fin des excursions ou du concours.</b></p><p>À noter : tant que vous n’avez pas de points, il s’agit d’un accès consultatif, il n’est donc pas nécessaire pour le moment que vous y personnalisiez vos infos.Lorsque vous remporterez vos premiers « points boutique », votre crédit de points ainsi que vos informations personnelles y seront automatiquement renseignés. Vous pourrez alors accéder à vos coordonnées pour les modifier, le cas échéant (choisir une autre adresse de livraison que celle de l’agence, par exemple).</p>'
  },  
  destination:{
    title:'Costa Rica',
    src:'/img/thumb.png',
    thumbnail1:'/img/thumbnail1.png',
    thumbnail2:'/img/thumbnail2.png',
    dateStart:'03 avril 2020',    
    dateEnd:'10 avril 2020',
    content:'<p>Le Costa Rica qui nous surprendra par sa douceur de vivre, ses richesses environnementales incroyables et la gentillesse de ses habitants : Pura Vida !</p><h1><i class="fas fa-map-marker-check"></i>Lieux Incourtounables</h1><ul><li>Mascate, capitale du Sultanat d’Oman</li><li>Souk de la Muttrah, l’un des plus vieux souks de la péninsule arabique</li><li> Croisière en bateau jusqu’à la plage secrète Bandar Khayran</li><li>Baignade dans le Wadi Bani Khalid</li><li>Découverte du Wahiba Sands et de la culture bédouine</li><li>Nuit dans un camp dans le désert</li></ul>'
  },
  general:{
    favorisLabel :'Les favoris sont affichés dans le résumé',
    btWeek:'1 semaine',
    btMonth: '1 mois',
    btYear: '1 an',
    labelStart : 'Début',
    labelEnd : 'Fin',
    labelTarget : 'Objectif',
    labelAll : 'Tous',
    dayOf : 'j-',
    formModalTitle : 'Créer un challenge',
    formTitle : 'Titre',
    formTitlePlaceholder : 'Exemple de titre',
    formName: 'Nom',
    formNamePlaceholder : 'Le nom',
    formFirstname: 'Prénom',
    formFirstnamePlaceholder : 'Le prénom',
    formEmail: 'Email',
    formEmailPlaceholder : 'L\'email',
    formRef : 'Référence',
    formRefBtOne : 'Vie',
    formRefBtTwo : 'Dommage',
    formRefBtThree : 'Qualité',
    formCat : 'Catégorie',
    formCriteria : 'Critère',
    formStart : 'Date de début',
    formEnd : 'Date de fin',
    formDatePlaceholder : '../../....',
    formObjectif : 'Objectif (nombre)',
    formObjectifPlaceholder : '',
    formBtCancel: 'Annuler',
    formBtCreate: 'Créer',
    formBtApply: 'Appliquer',
    formBtBrowse: 'Parcourir',
    formBtSave: 'Enregistrer',
    formBtSeeAll: 'Voir tous',
    formBtAddCollab: 'Ajouter un collaborateur',
    searchPlaceholder:'Rechercher un commercial',
    filter:'Filter',
    trier:'Trier',
    targetProgress:'En cours',
    targetDone:'Terminer',
    objective: 'Objectifs',
    objectiveAdvance: 'Objectif en avance',
    objectiveLate: 'Objectif en retard',
    objectiveDone: 'Objectif terminé',
    resumeTitle: 'Résumé',
    favorite: 'Favoris',
    modify: 'Modifier',
    resumeTrackingNumbers: 'Suivi des chiffres',
    resumeTrackingObjectives: 'Suivi des objectifs',
    resumeTrackingCommercials: 'Commerciaux suivi',
    resumeChallengesProgress: 'Challenges en cours',
    seeAllFavorites: 'Voir tous les favoris',
    thriftTitle: 'Épargne',
    commercialsTitle: 'Commerciaux',
    profileTitle:'Mon profil',
    profileTitleCollaborators:'Gestion des Collaborateurs',
    profileTitleNotifications:'Réglage notifications',
    profileTitleDisconnect:' Se déconnecter',
    profileTitleInfoPerso: 'Informations personnelles',
    profileTitleInfoAgence: 'Informations agences',
    profileTitleInfoMdp: 'Modifier mon mot de passe',
    profileFormLabel:{
      name:'Nom',
      firstname:'Prénom',
      email:'Email',
      codeAgence:'Code agence',
      adresse1:'Adresse 1',
      adresse2:'Adresse 2',
      city:'Ville',
      postalCode:'Code postal',
      region:'Région',
      mdp:'Mot de passe',
      mdpConfirm:'Confirmer le mot de passe'
    },
    profileTitleCollaboratorsSave: 'Collaborateurs enregistrer',
    profileTitleCollaboratorsSubTitle: 'Vous pouvez enregistrer ici vos collaborateurs pour l’accès aux points et jeux concours',
    profileNotifications:[
        {
          name:'Mise à jours chiffres',
          checked:false,
        },
        {
          name: 'Objectif (positif, négatif)',
          checked:true,
        },
        {
          name: 'Chiffres (positif, négatif)',
          checked:false,
        },
        {
          name: 'Challenge',
          checked:false,
        },
        {
          name: 'Jeu concours',
          checked:true,
        },
        {
          name: 'Mise à jours concours',
          checked:false,
        },
      ],
    challengeTitle : 'Challenge',
    challengeBtPopupMobile : 'Créer',
    challengeBtPopupDesktop : 'Créer un challenge',
    challengeSubTitle : 'Vos challenges en cours',
    challengeSubTitleCommercial : 'Challenges commerciaux',
    notificationsTitle : 'Notifications',

  },
  menus:[
    {
      link:'/admin/me/resume',
      text:'Resume',
      iconType:'fas',
      iconName:'file'
    },
    {
      link:'/admin/me/parcourir',
      text:'Parcourir',
      iconType:'far',
      iconName:'telescope'          
    },
    {
      link:'/admin/me/objectifs',
      text:'Objectifs',
      iconType:'far',
      iconName:'bullseye-arrow'          
    },
    {
      link:'/admin/me/commerciaux',
      text:'Commerciaux',
      iconType:'far',
      iconName:'users'          
    },
    {
      link:'/admin/me/challenges',
      text:'Challenges',
      iconType:'far',
      iconName:'trophy-alt'          
    } 
  ],
  menusFavorites:[
    {
      link:'/admin/me/favoris',
      text:'Favoris',
      iconType:'far',
      iconName:'star'
    }
  ],  
  menusGifts:[
    {
      link:'/admin/me/challenges/boutique',
      text:'Boutique cadeau',
      iconType:'far',
      iconName:'bags-shopping'          
    }
  ],  
  sideBarOptions: [
    {
        header: true,
        title: 'Vie',
        hiddenOnCollapse: false,
        class: 'part-first header'
    },
    {
        // href: '',
        to: { path: '' },               
        title: 'Production',
        icon: 'fas fa-chart-bar',
        class: 'part-first',
        child: [
            {
                // href: '/admin/me/parcourir/vie/p75635hfcn',
                to: { path: '/admin/me/parcourir/vie/nombre/p75635hfcn' },                
                title: 'Nombre',
            },
            {
              // href: '/admin/me/parcourir/vie/p7563hfcbn',
              to: { path: '/admin/me/parcourir/vie/montant/p7563hfcbn' },                
              title: 'Montant',
            },
            {
              // href: '/admin/me/parcourir/vie/p7535hfcbn',
              to: { path: '/admin/me/parcourir/vie/last/p7535hfcbn' },                
              class: 'last',
              title: '%UC',
            },
        ]                
    },       
    {
        href: '',
        to: { path: '' },
        title: 'Rachat',
        icon: 'fas fa-usd-square',
        class: 'part-first',
        id:'4',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
      ]                    
    },
    {
        // href: '',
        to: { path: '' },
        title: 'Portefeuille',
        icon: 'fas fa-wallet',
        class: 'part-first last',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]                   
    },
    {
        header: true,
        title: 'Dommages',
        hiddenOnCollapse: false,
        class: 'part-second header'
    },            
    {
        // href: '',
        to: { path: '' },
        title: 'Production',
        icon: 'fas fa-chart-bar',
        class: 'part-second',
        id:'12',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]   
    },
    {
        // href: '',
        to: { path: '' },
        title: 'Résiliation',
        icon: 'fas fa-file-excel',
        class: 'part-second',
        id:'16',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]                   
    },
    {
        // href: '',
        to: { path: '' },
        title: 'Solde',
        icon: 'fas fa-usd-square',
        class: 'part-second',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]                    
    },
    {
        // href: '',
        to: { path: '' },
        title: 'Taux de couverture',
        icon: 'fas fa-chart-line',
        class: 'part-second',
        id:'24',
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]                   
    },
    {
        // href: '',
        to: { path: '' },
        title: 'Portefeuille',
        icon: 'fas fa-wallet',
        class:"part-second last",
        child: [
          {
            // href: '/admin/me/parcourir/vie/p75635hfcn',
            to: { path: '/admin/me/parcourir/vie/p75635hfcn' },                
            title: 'Nombre',
          },
          {
            // href: '/admin/me/parcourir/vie/p7563hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7563hfcbn' },                
            title: 'Montant',
          },
          {
            // href: '/admin/me/parcourir/vie/p7535hfcbn',
            to: { path: '/admin/me/parcourir/vie/p7535hfcbn' },                
            class: 'last',
            title: '%UC',
          },
        ]                
    },
    {
        header: true,
        title: 'Qualité',
        hiddenOnCollapse: false,
        class: 'part-three header',
    },
    {
        href: '/admin/me/parcourir/qualite/p7563w5hfcbn',
        title: 'Clients AEL',
        icon: 'fad fa-user-robot',
        class: 'part-three',
    },                          
    {
        href: '/admin/me/parcourir/qualite/p756w35hfcbn',
        title: 'Complétude clients',
        icon: 'fas fa-wallet',
        class: 'part-three',
    },                          
    {
        href: '/admin/me/parcourir/qualite/p756d35hfcbn',
        title: 'Réclamations',
        icon: 'fas fa-wallet',
        class: 'part-three',
    },                          
    {
        href: '/admin/me/parcourir/qualite/p756c35hfcbn',
        title: 'Multidétention',
        icon: 'fas fa-wallet',
        class: 'part-three',
    },                          
    {
        href: '/admin/me/parcourir/qualite/p75635hfacbn',
        title: 'Enrichissement<br/>Contacts',
        icon: 'fas fa-wallet',
        class: 'part-three',
        child: [
          {
            href: '/admin/me/parcourir/qualite/p75s635hfcbn',
            title: 'Nombre',
          },
          {
            href: '/admin/me/parcourir/qualite/p75635hfgcbn',
            title: 'Montant',
          },
          {
            href: '/admin/me/parcourir/qualite/p75635hfcbn',
            title: '%UC',
          },
        ]          
    },                          
    {
        href: '/admin/me/parcourir/qualite/multi',
        title: 'Multi-détention<br/>Nouveaux clients',
        icon: 'fas fa-wallet',
        class: 'part-three',
    },                          
    {
        href: '/admin/me/parcourir/qualite/solde',
        title: 'Solde clients',
        class:'part-three last',
        icon: 'fas fa-wallet',
    },                          
  ],
  sideSearch: {
    options: [
      { value: null, text: 'RCR' },
      { value: 'a', text: '1ère excursion - Taux AEL <div class="target green">En cours</div>' },
      { value: 'b', text: 'Selected Option' },
      { value: { C: '3PO' }, text: 'This is an option with object value' },
      { value: 'd', text: 'This one is disabled', disabled: true }
    ],
    filters: [
      { text: 'Orange', value: 'orange' },
      { text: 'Apple', value: 'apple' },
      { text: 'Pineapple', value: 'pineapple' },
      { text: 'Grape', value: 'grape' }
    ]      
  },
  sideChallenges: {
    firstPart:{
      mainTitle:'Challenges',
      buttons:[
        {
          link:'/admin/me/challenges',
          text:'Tout parcourir',
          iconType:'fas',
          iconName:'trophy-alt'

        }
      ]
    },
    secondPart:{
      mainTitle:'Jeu concours',
      etiquette:'En cours',
      selects:[
        {
          text:'Pura vida 2020',
          id:'0'
        },
        {
          text:'Pura vida 2022',
          id:'0'
        }        
      ],
      buttons:[
        {
          link:'/admin/me/challenges/accueil',
          text:'Accueil',
          iconType:'far',
          iconName:'home-lg'
        },
        {
          link:'/admin/me/challenges/classement',
          text:'Classement',
          iconType:'far',
          iconName:'trophy'
        },
        {
          link:'/admin/me/challenges/excursions',
          text:'Excursions',
          iconType:'far',
          iconName:'umbrella-beach',
          notifications: '1'
        },
        {
          link:'/admin/me/challenges/destinations',
          text:'Destinations',
          iconType:'far',
          iconName:'plane-departure'
        },
        {
          link:'/admin/me/challenges/boutique',
          text:'Boutique',
          iconType:'far',
          iconName:'bags-shopping'
        },
        {
          link:'/admin/me/challenges/messagerie',
          text:'Messagerie',
          iconType:'far',
          iconName:'envelope'
        },
      ]  
    },
    threePart:{
      buttons:[
        {
          link:'/admin/me/resume',
          text:'Règlement',
          iconType:'fas',
          iconName:'clipboard-list-check'

        }
      ]      
    }
  },
  commercials: [
    {
      id:'0',
      fullname: 'Gendry charles-antoine',
      icon:"chart-line",
      number:"65%",
      class:"positif",
    },
    {
      id:'1',
      fullname: 'Allon Levy',
      icon:"chart-line",
      number:"65%",
      class:"positif",
    },
    {
      id:'2',
      fullname: 'Bacard Hugo',
      icon:"chart-line-down",
      number:"65%",
      class:"negatif", 
    },
    {
      id:'3',
      fullname: 'Belair Christophe',
      icon:"chart-line",
      number:"65%",
      class:"negatif", 
    },
    {
      id:'4',
      fullname: 'Metais Julien',
      icon:"chart-line",
      number:"65%",
      class:"positif", 
    },
    {
      id:'5',
      fullname: 'Simounet Christophe',
      icon:"chart-line",
      number:"35%",
      class:"positif", 
    },
    {
      id:'6',
      fullname: 'Catinot benjamin',
      icon:"chart-line",
      number:"85%",
      class:"positif", 
    },
    {
      id:'7',
      fullname: 'Delage Michel',
      icon:"chart-line",
      number:"85%",
      class:"positif", 
    },
    {
      id:'7',
      fullname: 'Delage Michel',
      icon:"chart-line",
      number:"85%",
      class:"positif", 
    },
    {
      id:'7',
      fullname: 'Delage Michel',
      icon:"chart-line",
      number:"85%",
      class:"positif", 
    },
  ],
  lists:{
      firstList:{
          title:'G1',
          subtitle:'Agents G1',
          ranking:[
            {
              target:'+1',
              fullname:'Allon Levy',
              result:'346,00'
            },
            {
              target:'-1',
              fullname:'Metais Julien',
              result:'346,00'
            },
            {
              target:'=',
              fullname:'Bacard Hugo',
              result:'346,00'
            },
            {
              target:'-2',
              fullname:'Bastaert Olivier',
              result:'346,00'
            },
            {
              target:'+1',
              fullname:'Gendry charles-antoine',
              result:'346,00'
            },
            {
              target:'+1',
              fullname:'Delage Michel',
              result:'346,00'
            },
            {
              target:'=',
              fullname:'Simounet Jonathan',
              result:'346,00'
            }
          ]
      },
      secondList:{
          title:'G2',
          subtitle:'Agents G2',
          ranking:[
            {
              target:'=',
              fullname:'Simounet Jonathan',
              result:'579,00'
            },
            {
              target:'-1',
              fullname:'Delage Michel',
              result:'346,00'
            },
            {
              target:'=',
              fullname:'Bastaert Olivier',
              result:'346,00'
            },
            {
              target:'-2',
              fullname:'Bacard Hugo',
              result:'346,00'
            },
            {
              target:'+1',
              fullname:'Metais Julien',
              result:'346,00'
            },
            {
              target:'+1',
              fullname:'Bastaert Olivier',
              result:'346,00'
            },
            {
              target:'=',
              fullname:'Bastaert Olivier',
              result:'346,00'
            }
          ]
      }
  },
  listsChallenge:[
    {
      target:'+1',
      fullname:'Delage Michel',
      result:'346,00',
      objectiv:true,
      travel:true,
    },
    {
      target:'-1',
      fullname:'Bastaert Olivier',
      result:'346,00',
      objectiv:true,
      travel:false,      
    },
    {
      target:'=',
      fullname:'Métais Julien',
      result:'346,00',
      objectiv:false,
      travel:true,      
    },
    {
      target:'-2',
      fullname:'Bastaert Olivier',
      result:'346,00', 
    }
  ],
  listsCommercials:{
      firstList:{
          title:'RCR',
          ranking:[
            {
              link:"123234.com",
              icon:"+1",
              fullname:'Delage Michel',
              result:'175',
              target:'+4',
            },
            {
              link:"123234.com",
              icon:"=",
              fullname:'Delage Michel',
              result:'155',
              target:'-1',
            },
            {
              link:"123234.com",
              icon:"-4",
              fullname:'Delage Michel',
              result:'115',
              target:'=',
            },
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Delage Michel',
              result:'95',
              target:'-2',
            }
          ]
      },
      secondList:{
          title:'Inspecteur C',
          ranking:[
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Bastaert Olivier',
              result:'95',
              target:'-2',
            },
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Bastaert Olivier',
              result:'95',
              target:'-2',
            },
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Bastaert Olivier',
              result:'95',
              target:'-2',
            },
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Bastaert Olivier',
              result:'95',
              target:'-2',
            }
          ]
      },
      thirdList:{
          title:'Inspecteur AP',
          ranking:[
            {
              link:"123234.com",
              icon:"+3",
              fullname:'Bastaert Olivier',
              result:'95',
              target:'-2',
            },
          ]
      },
  },
  listsAgents:[
      {
        link:"123234.com",
        icon:"+1",
        fullname:'Bastaert Olivier',
        result:'175',
        target:'+4',
      },
      {
        link:"123234.com",
        icon:"=",
        fullname:'Bastaert Olivier',
        result:'155',
        target:'-1',
      },
      {
        link:"123234.com",
        icon:"-4",
        fullname:'Bastaert Olivier',
        result:'115',
        target:'=',
      },
      {
        link:"123234.com",
        icon:"+3",
        fullname:'Bastaert Olivier',
        result:'95',
        target:'-2',
      }
  ],
  browse: {
    illustration : {
      src:'/img/browse_illustration.svg',
      title:"Aucun Favoris",
      desc:"Retrouvez ici les favoris des critères de votre suivi"
    }
  },
  commercialsHome: {
    illustration : {
      src:'/img/browse_illustration.svg',
      title:"Aucun suivi",
      desc:"Retrouvez ici le suivi de vos commerciaux"
    }
  },
  resume: {
    illustration : {
      src:'/img/resume_illustration.svg',
      title:"Heureux de vous revoir !",
      desc:"Les dernières données ont été mises à jour le <span>lundi 30 mai 2020</span>"
    }
  },
  listObjectiveResume:[
    {
      icon:"chart-line",
      number:"12",
      title:"Objectif positif en cours",
      target:"+1"
    },
    {
      icon:"bullseye-arrow",
      number:"23",
      title:"Objectif négatif en cours",
      target:"-1"
    },
    {
      icon:"bullseye-arrow",
      number:"2",
      title:"Objectif terminé",
      target:""
    }
  ],
  listCommercialResume:[
    {
      icon:"chart-line",
      number:"65%",
      fullname:"BASTAERT OLIVIER",
    },
    {
      icon:"bullseye-arrow",
      number:"55%",
      fullname:"BASTAERT OLIVIER",
      negatif:"true"
    },
    {
      icon:"bullseye-arrow",
      number:"33%",
      fullname:"BASTAERT OLIVIER",
    }
  ],
  productionCardSmall:[
    {
      title :'Epargne',
      id : '1',
      number :'+15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
            data: [86,114,106,106,107],
            borderColor: "rgb(0,106,162)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0
          }, { 
            data: [282,350,411,502,635],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 0
          }, { 
            data: [168,170,178,190,203],
            borderColor: "rgb(0,106,162)",
            fill: false,
            pointRadius: 0
          }
        ]
      }
    },
    {
      title :'Epargne',
      id : '2',      
      number :'-10 %',
      resultOne : '360',
      resultTwo : '860',
      date : '25 septembre 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
            data: [86,114,106,106,107],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0
          }, { 
            data: [82,150,511,202,435],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 0
          }, { 
            data: [178,130,198,220,303],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 0
          }
        ]
      }
    },
    {
      title :'Epargne',
      id : '3',      
      number :'-10 %',
      resultOne : '360',
      resultTwo : '860',
      date : '25 septembre 2020',
      dateTwo : '10 septembre 2019',
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
            data: [86,114,106,106,107],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0
          }, { 
            data: [82,150,511,202,435],
            borderColor: "rgb(128,128,128)",
            fill: false,
            pointRadius: 0
          }, { 
            data: [178,130,198,220,303],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 0
          }
        ]
      }
    }
  ],
  resumeFavorisProduction:{
      title :'Epargne',
      number :'+15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },  
  resumeFavorisResiliation:{
      title :'Total',
      number :'-5 %',
      resultOne : '1254',
      resultTwo : '1274',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },  
  resumeFavorisCompletude:{
      title :'Taux complétude PART',
      number :'-15 %',
      resultOne : '660',
      resultTwo : '260',
      date : '13 mars 2020',
      dateTwo : '10 septembre 2019',
    },  
  productionCardObjectiveChart:[
    {
      id : '1',
      title :'Epargne',
      allNumber : '125 000',   
      resultOne : '62 500',
      difference : '+5 000',
      date : '13 mars 2020',
      isNegative:false,
      isDone:false,      
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
            data: [282,300,461,452,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0,
          }, { 
            data: [282,350,411,502,635],
            borderColor: "rgb(0,106,162)",
            fill: false,
            pointRadius: 0,
          }]
      }
    },
    {
      id : '2',
      title :'Epargne 2',
      allNumber : '25 000',   
      resultOne : '22 000',
      difference : '-5 000',
      date : '13 mars 2020',
      isNegative:true,
      isDone:false,          
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
            data: [282,300,461,452,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0
          }, { 
            data: [282,350,411,502,635],
            borderColor: "rgb(240,180,15)",
            fill: false,
            pointRadius: 0
          }]
      }
    },
    {
      id : '3',
      title :'Epargne 3',
      allNumber : '100 000',   
      resultOne : '100 000',
      difference : '+5 000',
      date : '13 mars 2020',
      isNegative:false,
      isDone:true,          
      chart : {
        labels: [1500,1600,1700,1750,1800],
        datasets: [{ 
          data: [282,300,461,452,635],
          borderColor: "rgb(240,180,15)",
            fill: false,
            borderDash: [5,10],
            pointRadius: 0
          }, { 
            data: [282,350,411,502,635],
            borderColor: "rgb(90,197,145)",
            fill: false,
            pointRadius: 0
          }]
      }
    }
  ],
  notifications: 0  
}

// Getter functions
const getters = {
  getLogin( state ) {
    return state.login;
  },
  getPageTransition( state ) {
    return state.pageTransition;
  },
  getBlog( state ) {
    return state.blog;
  },
  getBoutique( state ) {
    return state.boutique;
  },
  getDestination( state ) {
    return state.destination;
  },
  getLists( state ) {
    return state.lists;
  },
  getListsChallenge( state ) {
    return state.listsChallenge;
  },
  getListsCommercials( state ) {
    return state.listsCommercials;
  },
  getListsAgents( state ) {
    return state.listsAgents;
  },
  getListsObjectiveResume( state ) {
    return state.listObjectiveResume;
  },
  getListsCommercialResume( state ) {
    return state.listCommercialResume;
  },
  getResumeFavorisProduction( state ) {
    return state.resumeFavorisProduction;
  },
  getResumeFavorisResiliation( state ) {
    return state.resumeFavorisResiliation;
  },
  getResumeFavorisCompletude( state ) {
    return state.resumeFavorisCompletude;
  },
  getMenu( state ) {
    return state.menus;
  },
  getBrowse( state ) {
    return state.browse;
  },
  getCommercialsHome( state ) {
    return state.commercialsHome;
  },
  getResume( state ) {
    return state.resume;
  },
  getGeneral( state ) {
    return state.general;
  },
  getMenuFavorites( state ) {
    return state.menusFavorites;
  },
  getMenuGifts( state ) {
    return state.menusGifts;
  },
  getCommercials( state ) {
    return state.commercials;
  },
  getSideBarMenuOptions( state ) {
    return state.sideBarOptions;
  },
  getNotifications( state ) {
    return state.notifications;
  },
  getSideSearch( state ) {
    return state.sideSearch;
  },
  getSideChallenges( state ) {
    return state.sideChallenges;
  },
  getProductionCardSmall( state ) {
    return state.productionCardSmall;
  },
  getProductionCardObjectiveChart( state ) {
    return state.productionCardObjectiveChart;
  },
  getAuthenticated( state ) {
    state.isLogged = ApiAuthentificationService.isAuthenticated();
    return state.isLogged;
  },
  getInitial() {
    const initial = ApiAuthentificationService.getCurrentUser();
    if(initial!= null){
      return utils.firstLetterUpper(initial.name) + utils.firstLetterUpper(initial.lastName);
    }else{
      return 'BC';
    }
  },
  getFullName() {
    const info = ApiAuthentificationService.getCurrentUser();
    if(info!= null){
    return utils.getCapitalizeFirstLetter(info.name.toLowerCase()) + ' ' + utils.getCapitalizeFirstLetter(info.lastName.toLowerCase());
    }else{
      return 'Benjamin Catinot'
    }
  },
  getScrollTop() {
    return state.scrollToBeforeLeave;
  },
  getScroll() {
    return state.scrollToBeforeEnter;
  }
}




// MUTATIONS functions
const mutations = {
  authentification (state) {
    state.isLogged = true
  },
  incrementNotifications (state) {
    state.notifications++
  }, 
  disconnect () {
    ApiAuthentificationService.signOut();
    router.push(process.env.VUE_APP_LOGIN_ROUTE);
  },
  setPageTransition(state,value) {
    console.log(value)
    if ("default" === value) {
      state.pageTransition.name = "router-view";
      state.pageTransition.mode = "in-out";
    }
    if ("back" === value) {
      state.pageTransition.name = "router-view-back";
      state.pageTransition.mode = "in-out";
    }
  },
  setScrollToBeforeLeave(state,value) {
    state.scrollToBeforeLeave = value;
  },
  setScrollToBeforeEnter(state,value) {
    state.scrollToBeforeEnter = value;
    console.log(state.scrollToBeforeEnter);
  }

}

//ACTION
const actions = {
  incrementNotifications ({commit}) {
    commit('incrementNotifications')
  },
  disconnect ({commit}) {
    commit('disconnect')
  },
  goBack ({commit}) {
    commit("setPageTransition", "default");
  },
  setDefaultTransition({commit}) {
    commit("setPageTransition", "back");
  },
  setScrollTop({commit},value) {
    commit("setScrollToBeforeLeave", value);
  },
  setScrollEnter({commit},value) {
    commit("setScrollToBeforeEnter", value);
  }
}

export default new Vuex.Store({
    state: state,
    mutations: mutations,
    getters:getters,
    actions:actions
  })



